import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVenmoComponent } from './simple-icons-venmo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVenmoComponent ],
    exports:      [ SimpleIconsVenmoComponent ],
    bootstrap:    []
})
export class SimpleIconsVenmoModule {}
